export const mutations = {
  SET_OPEN_PLAN(state, plan) {
    state.openPlan = plan;
  },
  SET_PLANS(state, data) {
    const { recurrents } = data;
    state.plans = { ...state.plans, ...recurrents };
  },
  SET_LIFETIME_PLANS(state, data) {
    state.lifetimePlans = data;
  },
  SET_INDIVIDUALS(state, data) {
    const { individuals } = data;
    state.individuals = [...state.individuals, ...individuals];
  },
  SAVE_PLAN(state, plan) {
    const planAlreadySaved = state.savedPlans.some((el) => el.id === plan.id);
    if (!planAlreadySaved) {
      state.savedPlans.push(plan);
    }
  },
  SET_STEP_ACTION(state, action) {
    state.firstStepAction = action;
  }
};

export const getters = {
  plansWithIndividual(state, getters, rootState, rootGetters) {
    const actualVector = rootState.vectors.actualVector;
    const merch = rootGetters['experience/getMerch'];
    const design = rootGetters['experience/getDesign'];
    let individualExtended = null;
    let individualSimple = null;
    let result = [];

    const isMerch = actualVector.attributes?.some((el) => el.key == 'merch_only');
    const experience = isMerch ? merch : design;

    if (actualVector.isSvg) {
      individualExtended = 9;
      individualSimple = 2;
    } else if (isMerch) {
      individualSimple = 8;
    } else {
      individualExtended = 8;
      individualSimple = 7;
    }

    individualSimple = individualSimple
      ? state.individuals.find((el) => el.id == individualSimple)
      : null;
    individualExtended = individualExtended
      ? state.individuals.find((el) => el.id == individualExtended)
      : null;

    const individual = {
      simple: individualSimple,
      extended: individualExtended
    };

    if (individual.simple || individual.extended) {
      result.push(individual);
    }
    if (state.plans[experience].length) {
      result.push(state.plans[experience][0]);
      result.push(state.plans[experience][1]);
    }

    return result;
  },
  plans(state, getters, rootState, rootGetters) {
    const design = rootGetters['experience/getDesign'];
    const experience = rootGetters['experience/getExperience'] || design;
    return state.plans[experience];
  },
  lifetimePlans(state) {
    return state.lifetimePlans;
  },
  openPlan(state) {
    return state.openPlan;
  }
};

export const actions = {
  OPEN_PLAN({ commit }, plan) {
    commit('SET_OPEN_PLAN', plan);
  },
  async LOAD_PLANS({ commit, state, rootGetters }) {
    const design = rootGetters['experience/getDesign'];
    const experience = rootGetters['experience/getExperience'] || design;
    if (!state.plans[experience].length) {
      try {
        const response = await this.$axios.get('plan/');
        const data = response.data.data;
        if (data) {
          commit('SET_INDIVIDUALS', { individuals: data.individuals });
          commit('SET_PLANS', { recurrents: { merch: data.merch, design: data.design } });
        }
      } catch (e) {
        console.error('Plans | LOAD_PLANS:', e);
      }
    }
  },
  async GET_PLAN({ commit }, id) {
    try {
      const {
        data: { data, error }
      } = await this.$axios.post(`plan/${id}/`);
      if (!error) {
        commit('SAVE_PLAN', data);
        return data;
      } else {
        console.error('Plans | GET_PLAN 1:', data);
      }
    } catch (error) {
      console.error('Plans | GET_PLAN 2:', error);
    }
  }
};

export const state = () => ({
  plans: {
    merch: [],
    design: []
  },
  individuals: [],
  lifetimePlans: [],
  openPlan: null,
  savedPlans: [],
  firstStepAction: ''
});
